<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M6.73529 10.9574C6.73529 8.73416 7.28024 7.13388 8.23214 6.09242C9.17731 5.05833 10.5929 4.5 12.5 4.5C14.4071 4.5 15.8227 5.05833 16.7679 6.09242C17.7198 7.13388 18.2647 8.73416 18.2647 10.9574C18.2647 13.1913 19.6077 15.5354 20.9996 17.3829C21.4289 17.9527 21.4675 18.7365 21.1846 19.3977C20.903 20.0556 20.3473 20.5 19.67 20.5H5.32995C4.65269 20.5 4.09698 20.0556 3.81544 19.3977C3.53248 18.7365 3.57113 17.9527 4.00043 17.3829C5.3923 15.5354 6.73529 13.1913 6.73529 10.9574Z"
      stroke="currentColor"
    />
    <path
      d="M15 20.5C15 21.8807 13.8807 23 12.5 23C11.1193 23 10 21.8807 10 20.5"
      stroke="currentColor"
    />
    <path d="M15 5C15 3.34315 13.8807 2 12.5 2C11.1193 2 10 3.34315 10 5" stroke="currentColor" />
  </svg>
</template>
